<template>
  <div>
    <v-card class="pa-2 pt-0 pb-0">
      <v-container>
        <v-row
          no-gutters
          align="center"
          class="mb-3"
        >
          <v-col class="headline">
            {{ headline }}
          </v-col>

          <v-col cols="auto">
            <v-btn
              small
              fab
              icon
              @click="hideModal"
            >
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          class="mb-3"
          no-gutters
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <slot />
          </v-col>
        </v-row>

        <v-col class="text-center my-3">
          <v-btn
            class="mr-1"
            rounded
            dark
            :loading="loading"
            color="secondary"
            @click="confirm"
          >
            OK
          </v-btn>
          <v-btn
            class="ml-1"
            outlined
            rounded
            color="grey"
            dark
            elevation="1"
            @click="hideModal"
          >
            BACK
          </v-btn>
        </v-col>
      </v-container>
    </v-card>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ default: 'Confirmation' }) headline: string
  @Prop({ default: false }) loading: boolean

  hideModal () {
    this.$emit('hide')
  }

  confirm () {
    this.$emit('confirm')
  }
}
</script>
